import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuthContext } from '@/contexts/AuthContext';
import OnboardingWizard from '@/components/onboarding/OnboardingWizard';
import { Loader2 } from 'lucide-react';

export default function Onboarding() {
  const { user, isLoading, needsOnboarding } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;
    if (!user) {
      navigate('/auth', { replace: true });
      return;
    }
    if (!needsOnboarding) {
      navigate('/painel', { replace: true });
    }
  }, [user, isLoading, needsOnboarding, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!user || !needsOnboarding) {
    return null;
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4 gap-6">
      <Link to="/" className="ow-logo" aria-label="OS Works">
        <span className="ow-logo__mark">
          <img src="/bee.png" alt="" />
        </span>
        <span className="ow-logo__wm">
          <span className="os">os</span>works
        </span>
      </Link>
      <OnboardingWizard />
    </div>
  );
}
